import { PHONE } from '../../../constants';
import s from 'pages/Registration/PersonalDetails/AccountAlreadyExists.module.scss';
import WarningTriangleIcon from 'assets/icons/warning-triangle.svg?react';
import { useTranslation } from 'react-i18next';

type Props = {
  onClick: () => void;
};

function AccountAlreadyExistsBox({ onClick }: Props) {
  const { t } = useTranslation();
  return (
    <div className={s.box} data-test="alreadyExistsBox-box">
      <div className={s.icon}>
        <WarningTriangleIcon data-test="alreadyExistsBox-warning-icon" />
      </div>
      <div className={s.body}>
        <div className={s.text} data-test="alreadyExistsBox-text">
          {t('personal_details:already_exists.text')}{' '}
          <span data-test="alreadyExistsBox-phone">{PHONE}</span>
        </div>
        <button
          className={s.button}
          type="button"
          onClick={onClick}
          data-test="alreadyExistsBox-button"
        >
          {t('personal_details:already_exists.button')}
        </button>
      </div>
    </div>
  );
}

export default AccountAlreadyExistsBox;
